import EventBus from '@/utils/eventBus'

export default {
  namespaced: true,
  state: {
    profileUser: {},
    profileCompanyName: '',
    profileDisplayName: '',
    profileLogoURL: '',
    menuList: [],
    permissionMap: {},
    activeIntegrations: [],
    notifications: {},
    changeLogUpdatedAlert: false
  },
  mutations: {
    // Set profile details based on response of '/profile' API call
    setProfile (state, profileDetails) {
      state.profileUser = profileDetails.user
      state.profileCompanyName = profileDetails.companyName
      state.profileDisplayName = profileDetails.displayName
      state.profileLogoURL = profileDetails.logoURL
      state.menuList = profileDetails.menu
      state.permissionMap = profileDetails.permissions,
      state.activeIntegrations = profileDetails.activeIntegrations,
      state.notifications = profileDetails.notifications

      EventBus.emitEvent(EventBus.EventTypes.permissionsUpdated)
    },
    setMenuList (state, menu) {
      state.menuList = menu
    },

    setNotificationSummary(state, summaryData) {
      state.notifications.unreadCount = summaryData.unreadCount
    },

    setChangeLogUpdated(state, updatedState) {
      state.changeLogUpdatedAlert = updatedState
    },
    clearProfile(state) {
      state.profileUser = {}
      state.profileCompanyName = ''
      state.profileDisplayName = ''
      state.profileLogoURL = ''
      state.menuList = []
      state.permissionMap = {}
      state.activeIntegrations = []
      state.notifications = {}
      state.changeLogUpdatedAlert = false
    }
  }
}
